module.exports = __webpack_public_path__ + "img/136.d795dfa2.jpg";